
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Comment est-il administré?`}</em></p>
    <p>{`Deux doses sont injectées à quatre semaines d'intervalle. Elles peuvent aussi
être espacées de trois mois.`}</p>
    <p>{`Le 11 octobre 2021, un comité d'experts de l'OMS a recommandé une troisième dose
de vaccin pour les patients dont les défenses immunitaires sont déjà affaiblies
par une autre maladie. Ce conseil est valable pour tous les vaccins homologués
par l'organisation, dont celui d'AstraZeneca.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;